import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import AddResidentScanType from './components/AddResidentScanType';

const { Cell } = ResponsiveGrid;

const ResidentScanType = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="住戶開通"
        breadcrumbs={[
          {
            name: '社區管理',
          },
          {
            name: '住戶開通',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <AddResidentScanType />
    </Cell>
  </ResponsiveGrid>
);

export default ResidentScanType;
